import {useTheme} from 'contexts/ThemeContext';
import React from 'react';
import {Image, TouchableOpacity} from 'react-native';
import styleSheet from './styles';

export enum ArrowButtonType {
  active,
  default,
  disabled,
}

export interface ArrowButtonProps {
  onPress: () => void;
  isLeft: boolean;
  type: ArrowButtonType;
}

const ArrowButton = (props: ArrowButtonProps) => {
  const theme = useTheme();
  const styles = styleSheet(theme);

  let backgroundColor = theme.colors.purple(0.13);
  let image = props.isLeft
    ? theme.images.activeLeftArrow
    : theme.images.activeRightArrow;
  switch (props.type) {
    case ArrowButtonType.default:
      backgroundColor = theme.colors.white;
      image = props.isLeft
        ? theme.images.defaultLeftArrow
        : theme.images.defaultRightArrow;
      break;

    case ArrowButtonType.disabled:
      backgroundColor = theme.colors.lightGrey;
      image = props.isLeft
        ? theme.images.disabledLeftArrow
        : theme.images.disabledRightArrow;
      break;

    case ArrowButtonType.active:
      break;
  }

  return (
    <TouchableOpacity
      disabled={props.type == ArrowButtonType.disabled}
      style={[
        styles.container,
        {
          backgroundColor,
        },
      ]}
      onPress={props.onPress}>
      <Image source={image} style={styles.image} />
    </TouchableOpacity>
  );
};

export default ArrowButton;
